import React from 'react';
import './PieCharts.scss';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import DataUnavailableMessage from '../../ui/DataUnavailableMessage';
import useWindowWidth from '../../../customHooks/useWindowWidth';

const PieCharts = ({
  PieChartData = [],
  legendLable = '',
  colors = ['#06C', '#EF9234', '#009596', '#C58C00', '#38812F'],
}) => {

  const windowWidth = useWindowWidth()
  const RADIAN = Math.PI / 180;

  const getTransformedData = (data) => {
    const total = Array.isArray(data)
      ? data.reduce((acc, item) => acc + (typeof item.value === 'number' ? item.value : 0), 0)
      : 0;
    const minPercent = 0.05; // 5%
    const minValue = total * minPercent;

    // Only boost values below 5%, leave others unchanged
    return data.map((entry) =>
      entry.value / total < minPercent
        ? { ...entry, boostedValue: minValue }
        : { ...entry, boostedValue: entry.value },
    );
  };

  const transformedData = getTransformedData(PieChartData);

  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent /* , index */,
    index,
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.51;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    const total = PieChartData.reduce((sum, entry) => sum + entry.value, 0);
    const realPercent = PieChartData[index].value / total;

    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor="middle"
        // fontWeight={400}
        dominantBaseline="central"
        alignmentBaseline="central"
        baselineShift={0}
        fontSize={windowWidth < 520 ? 13 :14}
        // className='piechart-hover'
      >
        {`${(realPercent * 100).toFixed(0)}%`}
      </text>
    );
  };

  return (
    <>
      <div className={`bar-chart ${PieChartData.length === 0 ? 'center' : ''}`}>
        {transformedData.length === 0 ? (
          <DataUnavailableMessage customMessage={`No data available`} />
        ) : (
          <>
            <ResponsiveContainer width="43%" height="100%">
              <PieChart
                width={450}
                height={450}
                fontSize="0.85em"
                margin={{
                  top: 5,
                  right: 25,
                  left: 15,
                  bottom: 12,
                }}
              >
                <Pie
                  data={transformedData}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  label={renderCustomizedLabel}
                  outerRadius={96}
                  innerRadius={40}
                  // dataKey="value"
                  dataKey="boostedValue"
                >
                  {transformedData?.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                  ))}
                </Pie>
                <Tooltip
                  formatter={(_value, name, { payload }) => [
                    <strong key="value">{payload.value}</strong>, // Show the real/original value
                    name,
                  ]}
                />
              </PieChart>
            </ResponsiveContainer>
            <div className="label">
              <span>{legendLable}</span>
              <ul>
                {PieChartData.map((entry, index) => (
                  <li key={`label-${index}`}>
                    <span
                      className="bullet"
                      style={{ backgroundColor: colors[index % colors.length] }}
                    ></span>
                    {entry.name}
                  </li>
                ))}
              </ul>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default PieCharts;
